export { default } from './SinglePostDealerWeb';
